
    var riot = require('riot')
    //src: starling/src/tags/waypoint-indication-box.html
riot.tag2('waypoint-indication-box',
  '<div id="waypoint-indication-box" riot-style="{this.getStyle()}"> </div>',
  '',
  '', function(opts) {
'use strict';

var _this = this;

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.canvas = this.opts.canvas;
this.canvas.waypointIndicationBoxTag = this;

this.top = 0;
this.left = 0;
this.height = 0;
this.width = 0;
this.opacity = 0;

this.getStyle = function () {
  return '\n        top: ' + _this.top + 'px;\n        left: ' + _this.left + 'px;\n        height: ' + _this.height + 'px;\n        width: ' + _this.width + 'px;\n        opacity: ' + _this.opacity + ';\n      ';
};

this.show = function (_ref) {
  var nodeIds = _ref.nodeIds;

  var nodes = nodeIds.map(function (nId) {
    return _store_instance2.default.getNode(nId);
  });

  var extentsList = _this.canvas.getContentExtents({ nodes: nodes });

  if (!extentsList) return;

  var extents = {
    et: extentsList[0],
    el: extentsList[1],
    eb: extentsList[2],
    er: extentsList[3]
  };

  var margin = 20;

  _this.top = extents.et - margin;
  _this.left = extents.el - margin;
  _this.height = extents.eb - extents.et + margin * 2;
  _this.width = extents.er - extents.el + margin * 2;
  _this.opacity = 1;
  _this.update();
};

this.hide = function () {
  _this.opacity = 0;
  _this.update();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('waypoint-indication-box')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/waypoint-indication-box.html
// module id = 672
// module chunks = 0